import type { Sponsor } from '@/types'

/**
 * Sponsors data for the Infinite Voltage robotics team.
 */
export const sponsors: Sponsor[] = [
  {
    logo: require('@/assets/sponsor/t2s_transparent_tight_smooth.png'),
    name: 'T2S Solutions, LLC'
  },
  {
    logo: require('@/assets/sponsor/Primary-ETC-logo-Landscape.png'),
    name: 'Energetics Technology Center (ETC)'
  },
  {
    logo: require('@/assets/sponsor/Raytheon_(RTX)_logo.svg.png'),
    name: 'Raytheon'
  },
  {
    logo: require('@/assets/sponsor/dcslogo_horiz.svg'),
    name: 'DCS'
  },
  {
    logo: require('@/assets/sponsor/Northrop_Grumman_logo_blue-on-clear_2020.svg'),
    name: 'Northrop Grumman'
  },
  {
    logo: require('@/assets/sponsor/msbr1.jpg'),
    name: 'Maryland Space Business Rountable'
  },
  {
    logo: require('@/assets/sponsor/TheHomeDepot.svg'),
    name: 'The Home Depot'
  },
  {
    logo: require('@/assets/sponsor/DoDSTEM/Full_Color_DoWSTEM_Logo.svg'),
    name: 'DoW STEM'
  }
]
